import styleToSelector from 'amkit3-modules/utils/style-to-selector'

const getStyle = () => {
  return require('./live/style.scssm')
}

const getSelector = () => {
  return styleToSelector(require('./live/style.scssm'))
}

const getTemplate = () => {
  return require('./live/template.html')
}

const getConfig = () => {
  return {
    controlBarAlwaysActive: true
  }
}

const getEndedRecommendTpl = () => {
  return require('./live/templates/ended-recommend.html')
}

export default ({
  getStyle,
  getSelector,
  getTemplate,
  getConfig,
  getEndedRecommendTpl
})
